import api from '../../../../api/client'

function toQuery(params = {}) {
  const query = {}
  if (params.searchField && params.searchField !== 'Page Name') query.searchField = params.searchField
  if (params.searchText) query.searchText = params.searchText
  if (params.company && params.company !== 'All') query.company = params.company
  if (params.branch && params.branch !== 'All') query.branch = params.branch
  if (params.page) query.page = params.page
  if (params.pageSize) query.pageSize = params.pageSize
  return query
}

export const COMPANY_OPTIONS = ['All']
export const BRANCH_OPTIONS = ['All']

export async function listStudentLandingPages(params = {}) {
  const { data } = await api.get('/admission/student-landing', { params: toQuery(params) })
  return data.items || []
}

export async function getStudentLandingPage(id) {
  const { data } = await api.get(`/admission/student-landing/${id}`)
  return data
}

export async function createStudentLandingPage(payload) {
  const { data } = await api.post('/admission/student-landing', payload)
  return data
}

export async function updateStudentLandingPage(id, payload) {
  const { data } = await api.put(`/admission/student-landing/${id}`, payload)
  return data
}

export async function deleteStudentLandingPage(id) {
  const { data } = await api.delete(`/admission/student-landing/${id}`)
  return data
}
